/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

export const MessageText = {
  LOGIN_TEXT: 'You have logged in successfully.',   // not needed
  LOGGEDIN_SUCCESS: 'You have logged in successfully.',// not needed
  GAUTH_REQUIRED: 'Provide Multi-factor Authentication code to login.',
  TWOFA_REQUIRED: 'Code has been sent to',
  USERNAME_PASS_NO_MATCH: 'Username and password do not match. Password is case-sensitive.',
  INVALID_MFA_NO_MATCH: 'Multi-factor Authentication code is invalid.',
  INVALID_TWOFA_NO_MATCH: 'Two-factor Authentication code is invalid.',
  INVALID_AUTH_CODE: 'Authentication code is invalid.',
  ROLES_ASSIGNED: 'Roles assigned successfully.',
  WENT_WRONG: 'Something went wrong.',
  ARCHIVE_SUCCESS: 'User archived successfully.',
  MFA_TOKEN_ACTIVATED: 'Multi-factor Authentication code is activated now please login.',
  MFA_TOKEN_EXPIRED: 'Multi-factor Authentication code expired. Please try again.',
  RESET_PASSWORD: 'Password reset successfully.',
  INVALID_MFA: 'Invalid Multi-factor Authentication code.',
  INVALID_RESET_CREDS: 'Invalid credentials please try again.',
  USER_ENABLED: 'User enabled successfully.',
  USER_ACTIVATED: 'User activated successfully.',
  USER_CREATED: 'User created successfully.',
  EMAIL_ALREADY_EXIST: 'Email already exists!.',
  EMAIL_FORMAT_INVALID: 'Email format is invalid.',
  FORCE_CHANGE_PASS: 'Please change your password.',
  ACRHIVE_USER: 'Are you sure you want to disable the user?',
  ACTIVATE_USER: 'Are you sure you want to activate the user?',
  ENABLE_USER: 'Are you sure you want to enable the user?',
  USER_STATUS_ENABLE: 'Enable User',
  USER_STATUS_ACTIVE: 'Active User',
  USER_STATUS_APPROVE: 'Approve User',
  USER_RESEND_PASSWORD: 'Resend Password',
  RESEND_PASSWORD: "Are you sure you want to resend the password to the user?",
  USER_STATUS_DISABLE: 'Disable User',
  LOGOUT_TITLE: 'Are you sure?',
  LOGOUT_TXT: 'Logout',
  CANCEL_TXT: 'Cancel',
  LOGOUT_DESC: 'Are you sure you want to logout?',
  VALIDATION_EMAIL_FORMAT: 'Please input your correct email.',
  VALIDATION_WORK_EMAIL_REQUIRED: 'Business email is required.',
  EMAIL_REQUIRED: 'Email is required.',
  VALIDATION_ROLE_REQUIRED: 'Role is required.',
  VALIDATION_TEAM_REQUIRED: 'Team is required.',
  VALIDATION_TEAM_NAME_REQUIRED: 'Team name is required.',
  TEAM_CREATED_SUCCESSFULLY: 'Team created successfully.',
  CREATE_TEAM_FAILED: 'Failed to create Team.',
  VALIDATION_EMAIL_REQUIRED: 'Email is required.',
  VALIDATION_MFA_CODE_REQUIRED: 'Multi-factor Authentication code is required.',
  VALIDATION_TWOFA_CODE_REQUIRED: 'Two-factor Authentication code is required.',
  VALIDATION_PASS_MATCH: 'New passwords and confirm new password must match.',
  VALIDATION_PASS_FORMAT: 'Must Contain %d Characters, One Uppercase, One Lowercase, One Number and One Special Case Character.',
  PASSWORD_MUST_FORMAT: 'The password must contain:',
  PASSWORD_MUST_FORMAT_TEXT: 'At least %d characters.',
  PASSWORD_UPPERCASE_FORMAT: 'Uppercase characters (A-Z)',
  PASSWORD_LOWERCASE_FORMAT: 'Lowercase characters (a-z)',
  PASSWORD_DIGITS_FORMAT: 'Digits (0-9)',
  PASSWORD_SPECIAL_CHARACTERS_FORMAT: 'Special characters (!@#$%^&*)',
  VALIDATION_OLD_PASS_REQUIRED: 'Temporary password is required.',
  VALIDATION_PASS_INVALID: 'Password format is invalid.',
  VALIDATION_PASS_REQUIRED_LOGIN: 'Password is required.',
  VALIDATION_PASS_REQUIRED: 'New password is required.',
  RESET_CODE_REQUIRED: 'Code is required.',
  VALIDATION_FIRSTNAME_REQUIRED: 'First name is required.',
  VALIDATION_EMAIL_DOMAIN: 'Please use business email address.',
  VALID_EMAIL_ADDRESS: 'Please enter valid email address.',
  VALIDATION_MIN_2: 'Field should have minimum 2 characters',
  VALIDATION_LASTNAME_REQUIRED: 'Last name is required.',
  VALIDATION_COMPANY_REQUIRED: 'Company name is required.',
  VALIDATION_DESIGNATION_REQUIRED: 'Designation name is required.',
  VALIDATION_LINKEDIN_REQUIRED: 'Linkedin profile url is not valid.',
  VALIDATION_PHONENUMBER_REQUIRED: 'Phone number is required.',
  VALIDATION_PHONENUMBER_FORMAT: 'Phone number is invalid.',
  VALIDATION_CONFIRM_PASS_REQUIRED: 'Confirm new password is required.',
  VALIDATION_TITLE_REQUIRED: 'Title is required.',
  VALIDATION_LOCATION_REQUIRED: 'Country is required.',
  VALIDATION_PARENTCOMP_REQUIRED: 'Parent Company is required.',
  VALIDATION_JOBFUN_REQUIRED: 'Job function is required.',
  VALIDATION_TRIALDAYS_REQUIRED: 'Trial days is required.',
  TRIAL_DAYS_SUCCESS: 'Trial Days updated successfully.',
  TRIAL_DAYS_FAILED: 'Failed to update Trial Days.',
  EXPIRY_DAY_SUCCESS: 'Expiry date updated successfully.',
  EXPIRY_DAY_FAILED: 'Failed to update expiry date.',
  TRIALDAYS_PERIOD: 'Trial Days should be between 2 and 100 days',
  SIGNUP_MSG_TITLE: 'Thanks for registering!',
  SIGNUP_MSG_DESC: "Our team will get in touch within 2 business days.",
  NO_RESULT: 'No result found.',
  RESET_CODE_SENT: 'New verification code is sent to your email.',
  RESET_CODE_FAILED: 'Failed to send reset verification code.',
  PASSWORD_CHANGE_SUCC: 'Your password has been changed successfully.',
  RESET_PASSWORD_CODE: 'Invalid credentials please try again.',
  LIMIT_EXCEED_PASSWORD: 'Reset limit exceed please try again after some time.',
  VALIDFILE: 'Users added sucessfully.',
  INVALIDFILE: 'There are errors in the file.Please rectify and try again.',
  INTERNAL_SERVER_ERROR: 'Internal server error. Please try again after some time.',
  REJECT_USER_SUCCESS: 'User reject successfully.',
  USER_STATUS_REJECT: 'Reject User',
  REJECT_USER_CONFORM: 'Are you sure you want to reject the user?',
  DOWNLOAD_SEARCH_TABLE_SUCCESS: 'User Document Search Report has been sent to your mailbox',
  DOWNLOAD_SEARCH_TABLE_ERROR: 'There was an issue generating the User Document Search Report',
  DOWNLOAD_COMPLETED: 'Download completed.',
  DOWNLOAD_FAILED: 'Download failed.',
  REQUIRED: "Required",
  SPECIAL_CHARACTERS_ARE_NOT_ALLOWED: "Special characters are not allowed.",
  VALID_USER_STATUS: "Temporary password sent to the user successfully.",
  INVALID_USER_STATUS: "Unable to resend password to this user.",
  HELP_TEXT_COPY_SECREAT_KEY: "Copy the above code into your authenticator app to manually set up two-factor authentication.",
  GUEST_SIGNUP_MSG_DESC: "As a guest, you now have 60 minutes of access to our trial database, which is a subset of our full database.",
  INVALID_GUEST_QR_Text: 'QR code is invalid.',
  MOBILE_Desktop_GUEST_SIGNUP_MSG_DESC: "Please note Infraclear is not optimized for mobile use. We invite you to try our platform on your desktop. Kindly try the URL mentioned in the email on the desktop.",
  MOBILE_GUEST_SIGNUP_MSG_DESC: "Please note Infraclear is not optimized for mobile use. We invite you to try our platform on your desktop. Check your email for details.",
  INVALID_DEVICE_Text: 'Please try using desktop browser',
  INVALID_GUEST_URL_Text: 'Invalid login URL',
  CLICK_SECOND_TIME_SAME_URL: "Your access as a guest user has been used up. Please use the login information provided to you in the email to access our trial database, which is a subset of our full database.",
  RESET_2FA_TEXT: "Reset two factor authentication",
  RESET_MFA: "Reset Multi Factor Authentication",
  ACTIVATE_2FA_TEXT: "Activate Two Factor Authentication",
  TWO_FA_TITLE: "two factor Authentication device on your cell phone or computer",
  HOW_TO_SETUP_2FA_TEXT: "How To Set Up 2-factor Authentication (2FA) On Your Cell Phone or Computer.",
  HOW_TO_SETUP_2FA_STEP_TWO_TEXT: "Open your Authenticator app, click on the “+” and use your device's camera to scan the QR code, or manually enter the “special key” or “set up key” below.",
  HOW_TO_SETUP_2FA_STEP_THREE_TEXT: "Infraclear should then appear on your list of accounts in your Authenticator. You will see a six-digit numerical code, which will change frequently. Input this code when asked to on the Infraclear login page.",
  TRIAL_USER_AUTHENTICATION_CODE_HELP_MESSAGE: "Multi-Factor Authentication Not Supported",
  APPROVE_USER_SUCCESS: 'User approved successfully.',
  RESET_TRIAL_USER_HELP_MESSAGE: "You haven't completed your account setup. Please set your password from the link in the email.",
  INVALID_ROLE_CHANGE_MESSAGE: "A premium user can't be changed to a trial user.",
  ASSIGN_ROLE: 'Assign Roles',
  ASSIGN_ROLE_USER: 'Are you sure you want to change the role of the user?',
  APPROVE_USER: 'Approve subscription request',
  REJECT_USER: 'Reject subscription request',
  APPROVE_USER_TEXT: 'Are you sure you want to approve the subscription request?',
  REJECT_USER_TEXT: 'Are you sure you want to reject the subscription request?',
  SESSION_EXPIRE_TITLE: 'Need more time?',
  SESSION_EXPIRE_HELP_TEXT: "Your session is about to expire.You'll be automatically signed out in ",
  SESSION_EXPIRE_HELP_TEXT_QUA: 'To continue your session, click on ',
  ERROR_ACCOUNT_DISABLED: 'Your account has been disabled. Please contact infraclear support team.',
  REACTIVATE_USER: 'Reactivate User',
  REACTIVATE_USER_DESC: 'Are you sure you want to reactivate the user?',
  REACTIVATED_SUCCESSFULLY: 'User Reactivated successfully.',
  INACTIVE_TEAM_ACCOUNT_USER_LOGIN: 'Your team account is inactive. Please contact your team administrator or support@infraclear.com.',
  RESET_LINK_TO_MAIL: 'Please check your email to set your password.',
  SOMETHING_WENT_WRONG: 'Something went wrong, Please try again later.',
  ACCOUNT_ALREADY_REGISTERED: 'Your account is already registered. Please check your email to set your password.',
  USER_TRIAL_EXPIRED: 'Your account has expired. Please contact support@infraclear.com.',
  FREE_TRIAL_RENTAL_CREDIT_EXHAUSTED: "Your team's free trial rental credit / trial days has been exhausted. Please contact your team admin and subscribe.",
  SSO_USER_LIMIT_REACHED: "Maximum users are logged in, please try again later.",
  USER_ALREADY_EXIST: 'User already exist.',
  NOT_AUTHORIZED_USER_SUBSCRIPTION: 'No active subscription found. Please subscribe to access Infraclear.',
  DEACTIVATE_SUBSCRIPTION_TITLE: 'Deactivate subscription',
  DEACTIVATE_SUBSCRIPTION_DESC: 'How would you like to deactivate this user\'s subscription?',
  DEACTIVATE_IMMEDIATELY: 'Deactivate immediately',
  DEACTIVATE_END_OF_SUBSCRIPTION: 'Deactivate at end of subscription',
  DEACTIVATE_SUCCESS: 'Subscription deactivated successfully.',
  DEACTIVATE_END_OF_SUBSCRIPTION_SUCCESS: 'Subscription will be deactivated at the end of the current billing period.',
  DEACTIVATE_FAILED: 'Failed to deactivate subscription.',
  DEACTIVATE_ALREADY_REQUESTED: 'Subscription deactivation was already requested.',
  SUBSCRIPTION_CANCELLATION_FAILED: 'Subscription cancellation failed.',
  CANCEL_DEACTIVATION_REQUEST: 'Cancel Deactivation',
  CANCEL_DEACTIVATION_SUCCESS: 'Deactivation request cancelled successfully.',
  CANCEL_DEACTIVATION_FAILED: 'Failed to cancel deactivation request.',
  CONFIGURATION_SAVED_SUCCESSFULLY: 'Configuration saved successfully.',
  CONFIGURATION_SAVED_FAILED: 'Failed to save configuration.',
  VALIDATION_FROM_REQUIRED: "From is required.",
  VALIDATION_FROM_MIN: "From must be at least 1.",
  VALIDATION_TO_REQUIRED: "To is required.",
  VALIDATION_TO_MIN: "To must be at least 1.",
  VALIDATION_TO_GREATER_THAN_FROM: "To must be greater than From.",
  VALIDATION_PRICE_REQUIRED: "Price is required.",
  VALIDATION_PRICE_MIN: "Price must be at least 1.",
};